/**
 * Manages the opening and closing of modals through event dispatching.
 * Provides a centralized way to control modal visibility across the application.
 * Supports backdrop display configuration and modal identification.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];
  static values = {
    displayBackdrop: { type: Boolean, default: true },
    id: String,
  };

  /**
   * Validates that a modal ID is provided on connect.
   * This ensures the controller knows which modal to toggle.
   * @throws {Error} If no modal ID is provided
   */
  connect() {
    if (!this.idValue) {
      throw new Error("Modal ID is required to know which modal to toggle");
    }
  }

  /**
   * Dispatches an event to request opening a modal.
   * The event includes the modal ID and backdrop display preference.
   * This allows other controllers to handle the actual opening.
   */
  requestOpen() {
    this.dispatch("requestModalOpen", {
      detail: { id: this.idValue, displayBackdrop: this.displayBackdropValue },
      prefix: false,
    });
  }
}
